import { Annotation } from "@app/layouts/Article/StorylineElements/Annotation/Annotation";
import { configCategory } from "@pub/config";
import { CustomClassContext } from "@sphtech/dmg-design-system";
import {
  Divider,
  ListGroup,
  Tab,
  Typography,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode, useContext } from "react";

import styles from "../category.module.css";
import { CategoryLayoutElementProps } from "../types/types";

const { Heading, Label } = Typography;

export default function CategoryIntroBlock({
  data,
}: CategoryLayoutElementProps): ReactNode {
  const customClass = useContext(CustomClassContext);
  const infoContainerClass = customClass?.categoryLayout?.infoContainer;
  const sectionContainerClass = customClass?.categoryLayout?.sectionContainer;
  const tabPath =
    data.path || (data.tagSlug && `/tag/${data.tagSlug}`) || "/latest-stories";

  return (
    <section
      className={cx(
        styles.bodyContainer,
        styles.categoryInfoContainer,
        sectionContainerClass,
        infoContainerClass,
      )}
    >
      {data.name && (
        <div
          className={cx(
            styles.headingContainer,
            data.listGroup || data.intro?.description?.value
              ? styles.headingWithTab
              : styles.headingStandalone,
            customClass?.categoryLayout?.categoryHeading,
            data.tagSlug && customClass?.tagLayout?.headingContainer,
          )}
        >
          {data.subHeading && <Label Element="span">{data.subHeading}</Label>}

          <Heading.SectionTitle nameZH={data.nameZH}>
            {data.name}
          </Heading.SectionTitle>
        </div>
      )}

      {data.intro?.description?.value && (
        <div className={cx(styles.categoryDescriptionContainer)}>
          <Typography.Body>
            <Annotation element={data.intro.description} />
          </Typography.Body>
        </div>
      )}

      {data.listGroup && (
        <div
          className={cx(
            styles.tabContainer,
            customClass?.categoryLayout?.tabContainer,
          )}
        >
          <ListGroup
            variant={configCategory.listGroupVariant}
            {...data.listGroup}
          />

          {!configCategory.hideSubmenuDivider && <Divider />}
        </div>
      )}

      {!!configCategory.filterBy?.options?.length && (
        <Tab
          label={configCategory.filterBy.label}
          data={configCategory.filterBy.options.map((option) => {
            const isSelected = data.storyType === option.storyType;
            return {
              text: option.text,
              url: isSelected ? tabPath : `${tabPath}/${option.pathSuffix}`,
              isSelected,
            };
          })}
        />
      )}
    </section>
  );
}
